import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Field, FieldArray } from 'redux-form'
import Checkbox from '@material-ui/core/Checkbox'
import { Radio, RadioGroup } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel'
import CheckIcon from '@material-ui/icons/Check';
import Multiselect from 'react-widgets/lib/Multiselect';
import Combobox from 'react-widgets/lib/Combobox';
import 'react-widgets/dist/css/react-widgets.css';
import DropdownList from 'react-widgets/lib/DropdownList';


export const renderField = (props) => {
    const { input, label, type, placeholder, className, required, asterisk, defaultValue = '', value, disabled, meta: { touched, error } } = props;

    return (
    <div className="mb-2 mr-2">
        {label != null &&
            <label>{label} {asterisk && <span className="text-danger">*</span>}</label>
        }
        <div>
            <input {...input}
                   type={type}
                   placeholder={placeholder}
                   required={required}
                   className={className}
                   defaultValue={defaultValue}
                   value={input.value || defaultValue || ''}

                   disabled={disabled}
            />
            {touched && error && <span className="field-error">{error}</span>}
        </div>
    </div>)
}

export const renderNumberField = ({ input, label, placeholder, className, required, asterisk, defaultValue, value, disabled, min, max, step, meta: { touched, error } }) => (
  <div className="mb-2 mr-2">
    {label!=null &&
      <label>{label} {asterisk && <span className="text-danger">*</span>}</label>
    }
    <div>
      <input {...input}
             type='number'
             placeholder={ placeholder }
             required={ required }
             className={ className }
             min={ min || -999999.99 }
             max={ max  || 999999.99 }
             step={ step || 0.01 }
             defaultValue={defaultValue}
             disabled={disabled} />
      {touched && error && <span className="field-error">{error}</span>}
    </div>
  </div>
)

export const renderTextareaField = ({ input, label, type, placeholder, className, required, asterisk, meta: { touched, error } }) => (
  <div className="mb-2 mr-2">
    <label>{label} {asterisk && <span className="text-danger">*</span>}</label>
    <div>
      <textarea {...input} placeholder={label} type={type} required={required} className={className}></textarea>
      {touched && error && <span className="field-error">{error}</span>}
    </div>
  </div>
)

export const renderSelectField = ({ input, label, required, placeholder, className, options, asterisk, defaultValue, disabled, meta: { touched, error } }) => (
  <div className="mb-2 mr-2">
    <label>{label} {asterisk && <span className="text-danger">*</span>}</label>
    <div>
      <select {...input} required={required} className={className} value={defaultValue} disabled={disabled}>
            <option value="" key={input.name+'0'}>---</option>
            {options.map(option => {
                return (
                  <option value={option.value} key={input.name+''+option.value}>{option.text}</option>
                )
              })
            }
      </select>
      {touched && error && <span className="field-error">{error}</span>}
    </div>
  </div>
)

export const renderCheckbox = ({ input, name, label, color, asterisk }) => (
  <div>
    <FormControlLabel
      control={
        <Checkbox
          name={name}
          checked={input.value ? true : false}
          onChange={input.onChange}
          color={color}
        />
      }
      label={label}
    />
  </div>
)

export const renderMultipleCheckbox = ({ input, name, val, label, color, asterisk, checked }) => (
  <div>
    <FormControlLabel
      control={
        <Checkbox
          name={name}
          value={val}
          checked={checked}
          onChange={input.onChange}
          color={color}
          icon={<CheckIcon />}
          checkedIcon={<CheckIcon />}
        />
      }
      label={label}
    />
  </div>
)

export const renderDateField = ({ input, label, type, placeholder, className, required, asterisk, meta: { touched, error } }) => (
  <div className="mb-2 mr-2">
    <label>{label} {asterisk && <span className="text-danger">*</span>}</label>
    <div>
      <input {...input} value={input.value!='' ? input.value.substring(0,10) : ''} type={type} placeholder={placeholder} required={required} className={className} />
      {touched && error && <span className="field-error">{error}</span>}
    </div>
  </div>
)

export const renderDateTimeField = ({ input, label, placeholder, className, required, asterisk, defaultTime = '00:00', meta: { touched, error } }) => {
  const displayValue = (() => {
    if (!input.value) return '';
    const v = String(input.value);
    if (v.includes('T')) return v.substring(0, 16);
    if (v.length >= 10) return `${v.substring(0, 10)}T${defaultTime}`;
    return v;
  })();

  return (
    <div className="mb-2 mr-2">
      <label>{label} {asterisk && <span className="text-danger">*</span>}</label>
      <div>
        <input
          {...input}
          value={displayValue}
          onChange={(e) => input.onChange(e.target.value)}
          type="datetime-local"
          placeholder={placeholder}
          required={required}
          className={className}
        />
        {touched && error && <span className="field-error">{error}</span>}
      </div>
    </div>
  );
}

const isBeforeToday = (value) => {
  if (!value) return false;
  const date = new Date(String(value).length === 10 ? `${value}T00:00` : value);
  if (isNaN(date.getTime())) return false;
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  return date < startOfToday;
};

// Date-time field that asks for confirmation when a date before today is chosen.
// Declining restores the value the field had before it was edited.
class PastDateWarningField extends React.Component {
  state = { warningOpen: false };
  valueOnFocus = '';

  handleFocus = (e) => {
    this.valueOnFocus = this.props.input.value;
    this.props.input.onFocus(e);
  };

  handleBlur = (e) => {
    const { input } = this.props;
    const value = e.target.value;
    if (value !== String(this.valueOnFocus).substring(0, 16) && isBeforeToday(value)) {
      this.setState({ warningOpen: true });
    }
    input.onBlur(input.value);
  };

  confirm = () => this.setState({ warningOpen: false });

  cancel = () => {
    this.props.input.onChange(this.valueOnFocus);
    this.setState({ warningOpen: false });
  };

  render() {
    const { input, label, placeholder, className, required, asterisk, defaultTime = '00:00', meta: { touched, error } } = this.props;
    const v = input.value ? String(input.value) : '';
    const displayValue = v.includes('T') ? v.substring(0, 16) : (v.length >= 10 ? `${v.substring(0, 10)}T${defaultTime}` : v);

    return (
      <div className="mb-2 mr-2">
        <label>{label} {asterisk && <span className="text-danger">*</span>}</label>
        <div>
          <input
            {...input}
            value={displayValue}
            onChange={(e) => input.onChange(e.target.value)}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            type="datetime-local"
            placeholder={placeholder}
            required={required}
            className={className}
          />
          {touched && error && <span className="field-error">{error}</span>}
        </div>
        <Modal isOpen={this.state.warningOpen} toggle={this.cancel} centered>
          <ModalHeader toggle={this.cancel} className="bg-danger text-white">Warning</ModalHeader>
          <ModalBody>
            <h4 className="text-danger font-weight-bold">
              WARNING: The start date is in the past which can cause serious technical and legal issues. Are you really sure?
            </h4>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.cancel}>Cancel</Button>
            <Button color="danger" onClick={this.confirm}>Yes, I am sure</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export const renderStartDateTimeField = (props) => <PastDateWarningField {...props} />;

export const renderDateFieldGerman = ({ input, label, type, placeholder, className, required, asterisk, meta: { touched, error } }) => {
  // Конвертуємо дату з YYYY-MM-DD в DD.MM.YYYY формат
  const formatDateToGerman = (dateString) => {
    if (!dateString || dateString === '') return '';
    
    // Якщо дата вже в німецькому форматі (DD.MM.YYYY)
    if (dateString.includes('.')) {
      return dateString;
    }
    
    // Якщо дата в форматі YYYY-MM-DD
    if (dateString.includes('-')) {
      const parts = dateString.substring(0, 10).split('-');
      if (parts.length === 3) {
        return `${parts[2]}.${parts[1]}.${parts[0]}`;
      }
    }
    
    return dateString;
  };

  // Конвертуємо дату з DD.MM.YYYY в YYYY-MM-DD для input[type="date"]
  const formatDateToISO = (dateString) => {
    if (!dateString || dateString === '') return '';
    
    // Якщо дата вже в ISO форматі (YYYY-MM-DD)
    if (dateString.includes('-')) {
      return dateString.substring(0, 10);
    }
    
    // Якщо дата в німецькому форматі (DD.MM.YYYY)
    if (dateString.includes('.')) {
      const parts = dateString.split('.');
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
      }
    }
    
    return dateString;
  };

  const handleChange = (e) => {
    const isoDate = e.target.value; // YYYY-MM-DD
    const germanDate = formatDateToGerman(isoDate);
    input.onChange(germanDate);
  };

  return (
    <div className="mb-2 mr-2">
      <label>{label} {asterisk && <span className="text-danger">*</span>}</label>
      <div>
        <input 
          {...input} 
          value={formatDateToISO(input.value)} 
          type={type || 'date'} 
          placeholder={placeholder} 
          required={required} 
          className={className}
          onChange={handleChange}
        />
       
        {touched && error && <span className="field-error">{error}</span>}
      </div>
    </div>
  );
};

export const renderDropdownListselect = ({ input, data, valueField, textField, filter, disabled, onSearch, messages, meta: { touched, error } }) =>
  <div>
    <DropdownList {...input}
      value={input.value?.charAt(0).toUpperCase() + input.value?.slice(1)} // requires value to be an array
      data={data}
      valueField={valueField}
      textField={textField}
      messages={messages}
      disabled={disabled}
    />
   {touched && error && <span className="field-error">{error}</span>}
  </div>


export const renderMultiselect = ({ input, data, valueField, textField, filter, disabled, onSearch, messages, className, asterisk, label, meta: { touched, error } }) =>
  <div className="mb-2">
    {label && <label>{label} {asterisk && <span className="text-danger">*</span>}</label>}
    <Multiselect {...input}
      onBlur={() => input.onBlur()}
      value={input.value || []} // requires value to be an array
      data={data}
      valueField={valueField}
      textField={textField}
      filter={filter}
      onSearch={onSearch}
      messages={messages}
      disabled={disabled}
      className={className}
    />
   {touched && error && <span className="field-error">{error}</span>}
  </div>


export const renderSelect = ({input = null ,data, valueField, textField, filter, disabled, onSearch, messages, meta: { touched, error } }) => {
  let inputData = input
  if (typeof(input?.value) === 'number' && data?.length) {
    inputData = {...inputData, value: data.filter(item => item.id === input?.value)}
  }
  if (input?.value?.length > 1) inputData = {...inputData, value: [inputData.value[1]]}


  return (
    <div>
      <Multiselect {...inputData}
                   onBlur={() => inputData.onBlur()}
                   value={
                       inputData.value || []
                   } // requires value to be an array
                   data={data}
                   valueField={valueField}
                   textField={textField}
                   filter={filter}
                   onSearch={onSearch}
                   messages={messages}
                   disabled={disabled}
      />
      {touched && error && <span className="field-error">{error}</span>}
    </div>)
}


export const renderCombobox = ({ input, data, valueField, textField, filter, disabled, onSearch, messages, className, asterisk, label, meta: {touched, error} }) =>
  <div className="mb-2">
    <label>{label} {asterisk && <span className="text-danger">*</span>}</label>
    <Combobox {...input}
      onBlur={() => input.onBlur()}
      value={input.value || []} // requires value to be an array
      data={data}
      valueField={valueField}
      textField={textField}
      filter={filter}
      onSearch={onSearch}
      messages={messages}
      disabled={disabled}
      className={className}
    />
    {touched && error && <span className="field-error">{error}</span>}
  </div>


export const renderRadioGroup = ({ input, defaultValue, ...rest }) => (
  <RadioGroup
    {...input}
    {...rest}
    value={defaultValue}
    onChange={(event, value) => input.onChange(value)}
  />
);

